import React from "react";
import InformTable from "../Components/InformTable";
import { formatDateIfValid } from "../utils/dateHelpers";

const formatFeatureFields = (obj: Record<string, any>) =>
    Object.entries(obj)
        .filter(([, val]) => val !== null && val !== undefined)
        .map(([key, val]) => ({
            property: key,
            value: key === "CreateDate"
                ? (formatDateIfValid(val) ?? String(val))
                : String(val),
        }));

// Legacy Created: { "Old": {}, "New": { Id, CreateDate, GroupId, Name } }
export const FeatureCreatedLegacy: React.FC<{ action: any }> = ({ action }) => {
    const data = formatFeatureFields(action?.New ?? {});

    return (
        <div className="inform_panel">
            <InformTable data={data} label="General" />
        </div>
    );
};

// Legacy Deleted: { "Old": { Id, CreateDate, GroupId, Name }, "New": {} }
export const FeatureDeletedLegacy: React.FC<{ action: any }> = ({ action }) => {
    const data = formatFeatureFields(action?.Old ?? {});

    return (
        <div className="inform_panel">
            <InformTable data={data} label="General" />
        </div>
    );
};
